import { c as _c } from "react/compiler-runtime";
import React from "react";
import { CookieBanner } from "./CookieBanner";
import { CookieBannerQueryResult } from "../../../../studio/sanity.types";
export const CookieBannerWrapper: React.FC<{
  cookieBannerConfig?: CookieBannerQueryResult;
}> = t0 => {
  const $ = _c(2);
  const {
    cookieBannerConfig
  } = t0;
  if (!cookieBannerConfig) {
    return null;
  }
  let t1;
  if ($[0] !== cookieBannerConfig) {
    t1 = <CookieBanner configuration={cookieBannerConfig} />;
    $[0] = cookieBannerConfig;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default CookieBannerWrapper;